import React, { createContext } from 'react'
import './i18n';  //// import i18n (needs to be bundled ;)) 
import { useTranslation } from 'react-i18next';
import { useAppCtx } from './app-ctx';

const ResortLoader = ({resortId, children}) => {
    const { t } = useTranslation();

    const {JOOMLA_VARS, CONFIG, searchCriterias} = useAppCtx();
    const [theResort, setResort] = React.useState(null);

    //console.log('ResortLoader(): Entry');
    

    React.useEffect(() => {
        //let vars = Joomla.getOptions('com_kurortlife.uri');
        const appRoot = JOOMLA_VARS.root;
        const apiPath = CONFIG.resortDetails;

        console.log('ResortPageLoader.useEffect(): searchCriterias', JSON.stringify(searchCriterias));

        // Abort on unmount: navigating away from the resort page before the
        // details arrive must not set state on an unmounted component.
        const controller = new AbortController();

        fetch(appRoot + apiPath, {
            method: 'POST',
            headers: {'Content-Type': 'application/json', 'X-CSRF-Token': JOOMLA_VARS.csrfToken || ''},
            body: JSON.stringify({
                resortId:resortId,
                search: searchCriterias
            }),
            signal: controller.signal
        })
        .then(response => response.json())
        .then(data => {
            setResort(data.resort);
        })
        .catch(error => {
            // Ignore cancellations caused by cleanup (unmount / re-fetch)
            if (error && error.name === 'AbortError') return;
            console.error('ResortPageLoader.useEffect(): fetch failed:', error);
        });

        return () => controller.abort();
    }, []);

    return (
        children(theResort)
    );
}

export default ResortLoader;